// https://stackoverflow.com/a/20169362/5455542
export const isNumber = (val: number): boolean =>
  typeof val === 'number' && isFinite(val);

export const roundIfNeeded = (value: number): string => {
  if (Number.isInteger(value)) {
    return value.toString();
  } else {
    return value.toFixed(2);
  }
};
